import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { checkLinkSubstitution } from '../../utils/functions';

function FeaturedChatMessage() {
    const { featuredMsg, participantsList, screenDimension } = useSelector(
        state => state.conf,
    );

    const { name, message, attachment } = featuredMsg;
    let { screenHeight, screenWidth } = screenDimension;

    let profile_image = featuredMsg?.profile_image;
    let userName = name;

    const featuredMsgUser = useMemo(() => {
        return participantsList[featuredMsg.token]
            ? participantsList[featuredMsg.token]
            : {};
    }, [participantsList, featuredMsg]);

    if (Object.keys(featuredMsgUser).length > 0) {
        userName = featuredMsgUser.name;
        profile_image = featuredMsgUser.profile_image;
    }

    if (featuredMsg?.hide_chat_for_guests) {
        return <></>;
    }

    let featureChatStyle = {
        bottom: `${(screenHeight * 6.5 / 100)}px`,
        left: `${screenWidth * 3 / 100}px`,
        zIndex: 9,
    }

    let featureChatTextStyle = {
        maxHeight: `${(screenHeight * 12 / 100)}px`,
        maxWidth: `${(screenWidth * 65 / 100)}px`,
        minWidth: `${screenWidth * 20 / 100}px`,
    };



    const handleDownload = () => {
        if (!attachment?.url) {
            return;
        }
        window.open(attachment.url, '_blank');
    };

    const formatFileSize = bytes => {
        if (!bytes) {
            return '';
        }
        if (bytes < 1024) {
            return bytes + ' B';
        }
        if (bytes < 1024 * 1024) {
            return (bytes / 1024).toFixed(1) + ' KB';
        }
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    return (
        <>
            <div className={`d-flex   position-absolute `} style={featureChatStyle} >
                <div className="featured_cir bg-dark d-flex align-items-center justify-content-center bg-white text-green">
                    {profile_image ? (
                        <img src={profile_image} alt="" />
                    ) : (
                        <span>{userName && userName[0]}</span>
                    )}
                </div>

                <div className="featured_modal d-flex flex-column position-relative">
                    <div
                        className={'featured_head pl-5 py-2 text-white w-55'}>
                        {userName}
                    </div>
                    <div className="featured_text bg-white pl-5 py-3 pr-3" style={featureChatTextStyle}>
                        {checkLinkSubstitution(message)}
                        {attachment && (
                            <div
                                className="chat-attachment-card cursor-pointer"
                                onClick={handleDownload}>
                                <div className="chat-attachment-icon">
                                    <svg
                                        width="1.5em"
                                        height="1.5em"
                                        viewBox="0 0 24 24"
                                        fill="currentColor">
                                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                                    </svg>
                                </div>
                                <div className="chat-attachment-info">
                                    <div className="chat-attachment-filename">{attachment.name}</div>
                                    <div className="chat-attachment-meta">
                                        {formatFileSize(attachment.size)} • Click to download
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    );
}

export default React.memo(FeaturedChatMessage);
